import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import {
  isCollectionFollowed,
  followCollection,
  unfollowCollection
} from 'common/api/GraphApi';
import Button from 'common/components/Button';
import FollowUnfollowButton from 'common/components/FollowUnfollowButton';
import get from 'common/tools/objects/get';
import trans from 'common/tools/translations/trans';

import AuthenticatedLink from './user/AuthenticatedLink';

const followText = trans('userspace.collections.follow');
const followedText = trans('userspace.collections.followed');
const unfollowText = trans('userspace.collections.unfollow');
const checkFollow = async (collectionId, setIsFollowed, setIsLoading) => {
  try {
    const response = await isCollectionFollowed(collectionId);
    setIsFollowed(
      !!get(response.data, [
        'me',
        'user',
        'social',
        'followedCollections',
        'edges',
        'length'
      ])
    );
  } finally {
    setIsLoading(false);
  }
};

const FollowUnfollowCollectionButton = ({ user, ownerId, collectionId }) => {
  const [isFollowed, setIsFollowed] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    checkFollow(collectionId, setIsFollowed, setIsLoading);
  }, [collectionId]);
  if (!user.passiveLoginDone || isLoading) {
    // This matches twig render in the user-card module
    return (
      <Button className="userprofile-hidden" size="sm" disabled>
        {followText}
      </Button>
    );
  }
  if (!user.passiveLoginDone || ownerId === user.account.id) return null;
  return (
    <AuthenticatedLink>
      <FollowUnfollowButton
        isFollowed={isFollowed}
        follow={() => {
          setIsFollowed(true);
          followCollection(collectionId);
        }}
        unfollow={() => {
          setIsFollowed(false);
          unfollowCollection(collectionId);
        }}
        unfollowButtonTheme="default"
        unfollowButtonType="full"
        followButtonType="full"
        followed
        followButtonTheme="inverse"
        followText={followText}
        followedText={followedText}
        unfollowText={unfollowText}
      />
    </AuthenticatedLink>
  );
};

FollowUnfollowCollectionButton.propTypes = {
  user: PropTypes.object,
  ownerId: PropTypes.string.isRequired,
  collectionId: PropTypes.string.isRequired
};

FollowUnfollowCollectionButton.defaultProps = {
  user: null
};

export default FollowUnfollowCollectionButton;
